import React, { useEffect } from 'react';
import './conteudo-painel-aviso-cookies.component.scss';
import { Box, Button, Checkbox, FormControl, FormLabel, InputLabel, MenuItem, Select, SelectChangeEvent, Tabs, TextField } from '@mui/material';
import Tab from '@mui/material/Tab';
import { useInput } from '../../hooks/useInput.hook';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import MenuModel, { ItensMenuModel } from '../../models/menu.model';
import { CONSTANTS } from '../../constants/constants';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddIcon from '@mui/icons-material/Add';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CamposMenuComponent from '../campos-menu/campos-menu.component';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import WhatsAppModel from '../../models/whatsapp.model';
import CookiesModel from '../../models/cookies.model';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type ConteudoPainelAvisoCookiesComponentProps = {
  setVal: (val: CookiesModel) => void;
  cookies?: CookiesModel;
}

function ConteudoPainelAvisoCookiesComponent(props: ConteudoPainelAvisoCookiesComponentProps) {

  const [avisoCookiesInput, setAvisoCookiesInput] = React.useState(props.cookies ? props.cookies?.aviso_cookies : false);
  const [textoInput, setTextoInput] = React.useState(props.cookies?.texto);
  const [legendaBotaoPoliticaInput, setLegendaBotaoPoliticaInput] = React.useState(props.cookies?.legenda_botao_politica);
  const [legendaBotaoAceiteInput, setLegendaBotaoAceiteInput] = React.useState(props.cookies?.legenda_botao_aceite);
  const [linkBotaoPoliticaInput, setLinkBotaoPoliticaInput] = React.useState(props.cookies?.link_botao_politica);

  const [valueTabs, setValueTabs] = React.useState(0);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const handleChangeItem = () => {
    props.setVal({
      aviso_cookies: avisoCookiesInput,
      legenda_botao_aceite: legendaBotaoAceiteInput ? legendaBotaoAceiteInput : '',
      legenda_botao_politica: legendaBotaoPoliticaInput ? legendaBotaoPoliticaInput : '',
      texto: textoInput ? textoInput : '',
      link_botao_politica: linkBotaoPoliticaInput ? linkBotaoPoliticaInput : '',
    });
  }

  return (
    <section className="conteudo-painel-aviso-cookies">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTabs}
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <h2>Aviso cookies</h2>
          <div className="campo w100">
            <FormControl>
              <FormLabel>Aviso cookies?</FormLabel>
              <Checkbox
                checked={avisoCookiesInput}
                onChange={(event) => setAvisoCookiesInput(event.target.checked)}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </FormControl>
          </div>
          {
            avisoCookiesInput &&
            <>
              <div className="campo w100">
                <TextField value={textoInput} onChange={(event) => setTextoInput(event.target.value)} label="Texto" />
                <p>Exemplo: Este site usa cookies para melhorar a experiência do usuário.</p>
              </div>
              <div className="campo w100">
                <TextField value={legendaBotaoPoliticaInput} onChange={(event) => setLegendaBotaoPoliticaInput(event.target.value)} label="Legenda botão política" />
                <p>Exemplo: Política de privacidade</p>
              </div>
              <div className="campo w100">
                <TextField value={linkBotaoPoliticaInput} onChange={(event) => setLinkBotaoPoliticaInput(event.target.value)} label="Link botão política" />
                <p>Exemplo: politica-de-privacidade *É preciso criar o menu com este id e adicionar os componentes nesta página</p>
              </div>
              <div className="campo w100">
                <TextField value={legendaBotaoAceiteInput} onChange={(event) => setLegendaBotaoAceiteInput(event.target.value)} label="Legenda botão aceite" />
                <p>Exemplo: Aceitar</p>
              </div>
            </>
          }
        </CustomTabPanel>
      </Box>
    </section>
  );
}

export default ConteudoPainelAvisoCookiesComponent;
